import domEvents from '../../../events/domEvents';
import tableTemplate, { renderTableHead, renderTableRow } from './default.html';
import './styling.pcss';

export default class Table extends HTMLTableElement {
    #columns: TableColumn[] = [];

    #columnIds: (string | ((column: StandardObjectInterface) => string))[] = [];

    readonly #data: StandardObjectInterface[] = [];

    set columns(columns: TableColumn[]) {
        this.#columns = columns;
        this.#render();
    }

    get columns(): TableColumn[] {
        return this.#columns;
    }

    constructor() {
        super();

        this.classList.add('nh-table-component');

        this.#columns = JSON.parse(this.dataset.columns ?? '[]');
        this.#data = JSON.parse(this.dataset.values ?? '[]');
    }

    public addColumns(columns: TableColumn[]): void {
        this.#columns = [...this.#columns, ...columns];
    }

    protected connectedCallback(): void {
        this.#render();
    }

    #render(): void {
        const tableContents = tableTemplate().content.cloneNode(true) as HTMLElement;
        this.#columnIds = this.#columns.map((column) => column.id);

        const rowTableHeadElement = tableContents.querySelector('tr');
        const tableBodyElement = tableContents.querySelector('tbody');

        this.#columns.forEach((column) => {
            rowTableHeadElement?.appendChild(renderTableHead(column));
        });

        let hasNhComponents = false;
        this.#data.forEach((data) => {
            const tableRow = renderTableRow(data, this.#columnIds);
            hasNhComponents =
                tableRow.querySelectorAll('[data-nh-component]').length > 0 ?? hasNhComponents;
            tableBodyElement?.appendChild(tableRow);
        });
        if (hasNhComponents) {
            document.dispatchEvent(
                new CustomEvent(domEvents.templateInstantiated, {
                    detail: tableBodyElement
                })
            );
        }

        this.innerHTML = '';
        this.appendChild(tableContents);
    }
}

if (!customElements.get('nh-table')) {
    customElements.define('nh-table', Table, { extends: 'table' });
}
